import { ITag } from '../components/tags-block/TagsBlock';

export const filterTagsWithNonEmptyValues = (tags?: ITag[]): ITag[] =>
	tags
		?.filter((tag) => tag.values?.some((value) => value?.trim().length))
		?.map((tag) => ({ ...tag, values: tag.values.filter((value) => value?.trim().length) })) ?? [];
